import React from 'react';
import { FaEye } from 'react-icons/fa';
import project1 from "../../images/Anis Ayser 1.jpg";
import project2 from "../../images/Anis Ayser 2.jpg";
import project3 from "../../images/Anis Ayser 3.jpg";
import project4 from "../../images/Anis Ayser 4.jpg";
import project5 from "../../images/Anis Ayser 5.jpg";
import project6 from "../../images/Anis Ayser 6.jpg";
import project8 from "../../images/Anis Ayser 8.jpg";
import project9 from "../../images/Anis Ayser 9.jpg";

import './Portfolio.css';

const Portfolio = () => {
    return (
        <div className='pt-28 overflow-x-hidden overflow-y-hidden' id='portfolio'>

            <div className="container mx-auto pb-32">
                <div className='text-center space-y-8'>
                    <h4 data-aos="fade-down" className='uppercase text-lg text-white font-thin tracking-[6px]'>Portfolio</h4>
                    <h2 data-aos="fade-up" className='text-4xl md:text-6xl color-font'>My Recent Web Design & <br /> Some Past Projects.</h2>
                </div>
                <div className="grid grid-cols-2 gap-8 mt-20">

                    <div className='-skew-y-12 col-span-2 sm:col-span-1'>
                        <div data-aos="flip-left" data-aos-easing="ease-out-cubic" className='text-center bg-[#0c0c0f] space-y-10 p-10 '>
                            <div className='space-y-5'>
                                <h4 className='text-2xl text-white'>Trendy Tees</h4>
                                <p className='text-base text-slate-300 font-thin'>Full Stack (MERN), Redux, RTK-Query eCommerce Website.</p>
                            </div>
                            <div className='bg-gradient-to-r from-neutral-content p-2'>
                                <div className='overflow-hidden h-80 rounded'>
                                    <img src={project9} className="object-cover object-top hover:object-bottom h-full w-full duration-[5s]" alt="" />
                                </div>
                            </div>
                            <div>
                                <a href="https://trendy-tees.vercel.app/" target="_blank" rel="noopener noreferrer" className='btn space-x-4 capitalize'><FaEye className='text-xl' /> <span className='tracking-[1px] text-md'>Live Preview</span></a>
                            </div>
                        </div>
                    </div>

                    <div className='skew-y-12 col-span-2 sm:col-span-1'>
                        <div data-aos="flip-right" data-aos-easing="ease-out-cubic" className='text-center bg-[#0c0c0f] space-y-10 p-10 '>
                            <div className='space-y-5'>
                                <h4 className='text-2xl text-white'>Yum City</h4>
                                <p className='text-base text-slate-300 font-thin'>Full Stack (MERN) Food Blog Website.</p>
                            </div>
                            <div className='bg-gradient-to-r from-neutral-content p-2'>
                                <div className='overflow-hidden h-80 rounded'>
                                    <img src={project8} className="object-cover object-top hover:object-bottom h-full w-full duration-[5s]" alt="" />
                                </div>
                            </div>
                            <div>
                                <a href="https://yum-city-react.vercel.app/" target="_blank" rel="noopener noreferrer" className='btn space-x-4 capitalize'><FaEye className='text-xl' /> <span className='tracking-[1px] text-md'>Live Preview</span></a>
                            </div>
                        </div>
                    </div>

                    <div className='-skew-y-12 col-span-2 sm:col-span-1'>
                        <div data-aos="fade-right" data-aos-easing="ease-out-cubic" className='text-center bg-[#0c0c0f] space-y-10 p-10 '>
                            <div className='space-y-5'>
                                <h4 className='text-2xl text-white'>Fine Wrists</h4>
                                <p className='text-base text-slate-300 font-thin'>Full Stack (MERN) online E-commerce hand watch shop.</p>
                            </div>
                            <div className='bg-gradient-to-r from-neutral-content p-2'>
                                <div className='overflow-hidden h-80 rounded'>
                                    <img src={project1} className="object-cover object-top hover:object-bottom h-full w-full duration-[5s]" alt="" />
                                </div>
                            </div>
                            <div>
                                <a href="https://fine-wrists-70ad0.web.app/" target="_blank" rel="noopener noreferrer" className='btn space-x-4 capitalize'><FaEye className='text-xl' /> <span className='tracking-[1px] text-md'>Live Preview</span></a>
                            </div>
                        </div>
                    </div>

                    <div className='skew-y-12 col-span-2 sm:col-span-1'>
                        <div data-aos="fade-left" data-aos-easing="ease-out-cubic" className='text-center bg-[#0c0c0f]  space-y-10 p-10 '>
                            <div className='space-y-5'>
                                <h4 className='text-2xl text-white'>Real Food</h4>
                                <p className='text-base text-slate-300 font-thin'>A multi vendor online E-commerce grocery shop.</p>
                            </div>
                            <div className='bg-gradient-to-l from-neutral-content p-2'>
                                <div className='overflow-hidden h-80 rounded'>
                                    <img src={project6} className="object-cover object-top hover:object-bottom h-full w-full duration-[5s]" alt="" />
                                </div>
                            </div>
                            <div>
                                <a href="https://cerulean-marzipan-08dae4.netlify.app/" target="_blank" rel="noopener noreferrer" className='btn space-x-4 capitalize'><FaEye className='text-xl' /> <span className='tracking-[1px] text-md'>Live Preview</span></a>
                            </div>
                        </div>
                    </div>

                    <div className='skew-y-12 col-span-2 sm:col-span-1'>

                        <div data-aos="fade-right" data-aos-easing="ease-out-cubic" className='text-center bg-[#0c0c0f]  space-y-10 p-10'>
                            <div className='space-y-5'>
                                <h4 className='text-2xl text-white'>Portfolio Design</h4>
                                <p className='text-base text-slate-300 font-thin'>A Complete Portfolio Website.</p>
                            </div>
                            <div className='bg-gradient-to-r from-neutral-content p-2'>
                                <div className='overflow-hidden h-80 rounded'>
                                    <img src={project2} className="object-cover object-top hover:object-bottom h-full w-full duration-[5s]" alt="" />
                                </div>
                            </div>
                            <div>
                                <a href="https://heartfelt-marigold-9459d8.netlify.app/" target="_blank" rel="noopener noreferrer" className='btn space-x-4 capitalize'><FaEye className='text-xl' /> <span className='tracking-[1px] text-md'>Live Preview</span></a>
                            </div>
                        </div>
                    </div>

                    <div className='-skew-y-12 col-span-2 sm:col-span-1'>
                        <div data-aos="fade-left" data-aos-easing="ease-out-cubic" className='text-center bg-[#0c0c0f]  space-y-10 p-10'>
                            <div className='space-y-5'>
                                <h4 className='text-2xl text-white'>Alpha Medical</h4>
                                <p className='text-base text-slate-300 font-thin'>A Health care website where you can book appointment with any doctor.</p>
                            </div>
                            <div className='bg-gradient-to-l from-neutral-content p-2'>
                                <div className='overflow-hidden h-80 rounded'>
                                    <img src={project5} className="object-cover object-top hover:object-bottom h-full w-full duration-[5s]" alt="" />
                                </div>
                            </div>
                            <div>
                                <a href="https://alpha-medical-fe5a6.web.app/" target="_blank" rel="noopener noreferrer" className='btn space-x-4 capitalize'><FaEye className='text-xl' /> <span className='tracking-[1px] text-md'>Live Preview</span></a>
                            </div>
                        </div>
                    </div>

                    <div className='skew-y-12 col-span-2 sm:col-span-1'>
                        <div data-aos="flip-left" data-aos-easing="ease-out-cubic" className='text-center bg-[#0c0c0f]  space-y-10 p-10'>
                            <div className='space-y-5'>
                                <h4 className='text-2xl text-white'>Golden Wings</h4>
                                <p className='text-base text-slate-300 font-thin'>A tourisem website where you can book your tour.</p>
                            </div>
                            <div className='bg-gradient-to-r from-neutral-content p-2'>
                                <div className='overflow-hidden h-80 rounded'>
                                    <img src={project4} className="object-cover object-top hover:object-bottom h-full w-full duration-[5s]" alt="" />
                                </div>
                            </div>
                            <div>
                                <a href="https://golden-wings-7050a.web.app/" target="_blank" rel="noopener noreferrer" className='btn space-x-4 capitalize'><FaEye className='text-xl' /> <span className='tracking-[1px] text-md'>Live Preview</span></a>
                            </div>
                        </div>
                    </div>


                    <div className='-skew-y-12 col-span-2 sm:col-span-1'>
                        <div data-aos="flip-right" data-aos-easing="ease-out-cubic" className='text-center bg-[#0c0c0f]  space-y-10 p-10'>
                            <div className='space-y-5'>
                                <h4 className='text-2xl text-white'>Honda</h4>
                                <p className='text-base text-slate-300 font-thin'>A website where you can find your desier bike.</p>
                            </div>
                            <div className='bg-gradient-to-l from-neutral-content p-2'>
                                <div className='overflow-hidden h-80 rounded'>
                                    <img src={project3} className="object-cover object-top hover:object-bottom h-full w-full duration-[5s]" alt="" />
                                </div>
                            </div>
                            <div>
                                <a href="https://heuristic-brattain-2ccb99.netlify.app/" target="_blank" rel="noopener noreferrer" className='btn space-x-4 capitalize'><FaEye className='text-xl' /> <span className='tracking-[1px] text-md'>Live Preview</span></a>
                            </div>
                        </div>
                    </div>



                </div>
            </div>

            <div className="w-3/5 h-1 bg-gradient-to-r from-neutral-content z-50"></div>


        </div >
    );
};

export default Portfolio;